import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';
import Select from 'react-select';

import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete';
import ACMedia from '../../atoms/ACMedia';

import ACStatus from '../../atoms/ACStatus';
import { getCustomisedTypes, getMediaForUIName } from '../../common/global';

import styles from './PlaceDetails.module.scss';
export default class PlaceDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.onChangeAddress = this.onChangeAddress.bind(this);
    this.onSelectAddress = this.onSelectAddress.bind(this);

    this.onChangePlaceType = this.onChangePlaceType.bind(this);
  }

  componentDidUpdate(prevProps) {
    const { media = {} } = this.props;
    if (!isEmpty(media) && media !== prevProps.media) {
      this.updateMedia(media);
    }
  }

  updateMedia(media) {
    const { place = {} } = cloneDeep(this.props);
    const { name } = media;
    switch (name) {
      case 'placeMedia':
        const placeMedia = place.media || { type: 'image', url: '' };
        placeMedia.url = media.url;
        this.props.onUpdatePlaceDataFunc('media', placeMedia);
        break;
      default:
        break;
    }
  }

  onChangeAddress(address) {
    let where = {
      address,
    };

    this.props.onUpdatePlaceAddressFunc(where);
  }

  onChangeText(key, event) {
    let value = event.target.value;
    this.props.onUpdatePlaceDataFunc(key, value);
  }

  onChangeNote(key, event) {
    const { place = {} } = this.props;
    let { note = {} } = place;
    note[key] = event.target.value;
    this.props.onUpdatePlaceNoteFunc(note);
  }

  onChangePlaceType(placeType) {
    this.props.onUpdatePlaceDataFunc('type', placeType.value || '');
  }

  onSelectAddress(address) {
    geocodeByAddress(address)
      .then(results => {
        if (results && results[0]) {
          let r = results[0];

          let where = {};

          if (!r.address_components) return;
          const acs = r.address_components;

          const country = acs.find(ac => {
            return ac.types.includes('country');
          });
          country && country.long_name ? (where.country = country.long_name) : (where.country = '');

          const state = acs.find(ac => {
            return ac.types.includes('administrative_area_level_1');
          });
          state && state.long_name ? (where.state = state.long_name) : (where.state = '');

          const city = acs.find(ac => {
            return ac.types.includes('locality');
          });
          city && city.long_name ? (where.city = city.long_name) : (where.city = '');
          where.address = r.formatted_address || '';

          this.props.onUpdatePlaceAddressFunc(where);
        }
      })
      .catch(error => console.error('Error', error));
  }

  onUploadPlaceMedia = e => {
    if (!e.target) return null;
    const { files = [] } = e.target;
    const mediaFor = {
      ui: getMediaForUIName().place,
      name: 'placeMedia',
      s3FolderName: 'generic',
    };
    const { place = {}, uploadMediaFunc } = this.props;
    const { media } = place;
    uploadMediaFunc(mediaFor, media.type || '', files[0] || {});
  };

  renderTop(place) {
    const { name = '', status = '' } = place;

    return (
      <div className={styles.top}>
        <div className={styles.header}>Details</div>
        <div>
          <span className={styles.placeName}>
            <div className={styles.name}>
              <TextField
                value={name}
                className={styles.nameText}
                onChange={e => this.onChangeText('name', e)}
                placeholder="Place Name"
              />
            </div>
          </span>
          <ACStatus
            status={status}
            text={status}
            isEditable={true}
            type="place"
            onChangeFunc={e => this.onChangeText('status', e)}
            key="placeStatusKey"
          />
        </div>
      </div>
    );
  }

  renderPlaceTypes() {
    const { type = '' } = this.props.place;
    const placeTypes = getCustomisedTypes();

    if (isEmpty(placeTypes)) return <div />;

    let mPlaceTypes = [];
    let mSelectedPlaceType = {
      label: '',
      value: '',
    };
    if (!isEmpty(type)) {
      const findPlaceType = placeTypes.filter(pT => {
        return pT.value === type;
      });

      if (!isEmpty(findPlaceType))
        mSelectedPlaceType = {
          label: findPlaceType[0].name,
          value: findPlaceType[0].value,
        };
    }
    placeTypes.forEach(pT => {
      mPlaceTypes.push({
        label: pT.name,
        value: pT.value,
      });
    });

    return (
      <div className={styles.placeTypesContainer}>
        <span
          style={{
            fontSize: '12px',
            width: '200px',
          }}
        >
          Place Type
        </span>
        <Select
          className={styles.placeTypeSelect}
          inputId="react-select-single"
          TextFieldProps={{
            label: 'PlaceType',
            InputLabelProps: {
              htmlFor: 'react-select-single',
              shrink: true,
            },
            placeholder: 'Select a Place Type',
          }}
          options={mPlaceTypes}
          value={mSelectedPlaceType}
          onChange={this.onChangePlaceType}
        />
      </div>
    );
  }

  renderAddressDetails(place) {
    const { where = { address: '', city: '', state: '', country: '' } } = place;

    const { address, city, state, country } = where;

    return (
      <div>
        {' '}
        <PlacesAutocomplete
          value={address}
          onChange={this.onChangeAddress}
          onSelect={this.onSelectAddress}
        >
          {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
            <div className={styles.placesAutoComplete}>
              <div className={styles.placesAutoCompleteMain}>
                <span>Address</span>
                <input
                  {...getInputProps({
                    placeholder: 'Address, Suburb, State, Country',
                  })}
                />
              </div>
              <div className={styles.placesAutoCompleteSelect}>
                {loading && <div>Loading...</div>}
                {suggestions.map(suggestion => {
                  const className = suggestion.active
                    ? styles.suggestionItemActive
                    : styles.suggestionItem;
                  return (
                    <div
                      {...getSuggestionItemProps(suggestion, {
                        className,
                      })}
                    >
                      <span>{suggestion.description}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </PlacesAutocomplete>
        <TextField
          id="simple-start-adornment-city"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                City
              </InputAdornment>
            ),
          }}
          value={city}
          className={styles.textField}
          disabled
        />
        <TextField
          id="simple-start-adornment-state"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                State
              </InputAdornment>
            ),
          }}
          value={state}
          className={styles.textField}
          disabled
        />
        <TextField
          id="simple-start-adornment-country"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start" className={styles.adornment}>
                Country
              </InputAdornment>
            ),
          }}
          value={country}
          className={styles.textField}
          disabled
        />
      </div>
    );
  }

  render() {
    const { place } = this.props;
    const { media = {} } = place;
    if (isEmpty(place)) return <div />;

    const { note = { public: '' } } = place;
    return (
      <div className={styles.root}>
        {this.renderTop(place)}
        {this.renderPlaceTypes()}
        {
          <TextField
            value={note.public}
            className={styles.textField}
            multiline={true}
            rows="4"
            onChange={e => this.onChangeNote('public', e)}
            id="simple-start-adornment-note"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" className={styles.adornment}>
                  Information
                </InputAdornment>
              ),
            }}
          />
        }
        <ACMedia
          name="placeMedia"
          media={media}
          accept="image/*"
          onUploadMediaFunc={this.onUploadPlaceMedia}
          isMediaTypeDisabled={true}
        />
        <div className={styles.bottom}>{this.renderAddressDetails(place)}</div>
      </div>
    );
  }
}
